'use strict';

function isObject(val) {
    return val !== null && typeof val === 'object';
}

function encode(val) {
    return encodeURIComponent(val).
        replace(/%40/gi, '@').
        replace(/%3A/gi, ':').
        replace(/%24/g, '$').
        replace(/%2C/gi, ',').
        replace(/%20/g, '+').
        replace(/%5B/gi, '[').
        replace(/%5D/gi, ']');
}

function buildURL(url, params) {
    if (!params || !isObject(params)) {
        return url;
    }

    var newUrl = url,
        serializedParams = [];

    Object.keys(params).forEach(function(key) {
        serializedParams.push(encode(key) + '=' + encode(params[key]));
    });

    if (serializedParams.length) {
        var hashmarkIndex = newUrl.indexOf('#');
        if (hashmarkIndex > -1) {
            newUrl = newUrl.slice(0, hashmarkIndex);
        }

        newUrl += (newUrl.indexOf('?') === -1 ? '?' : '&') + serializedParams.join('&');
    }

    return newUrl;
}

module.exports = {
    isObject: isObject,
    encode: encode,
    buildURL: buildURL
};